import { Form } from "antd";
import React from "react";
import { SelectFromReference } from "src/components/SelectFromReference";
import { edAttrField } from "src/pages/ManagementPage/Obj2Tab/EdAttribute";
import { loadAllObjectAttsOptions } from "../../loadAllObjectAttsOptions";
import { edCompField } from "../ParamsEditorInfo2";

export const FinancialInputEdProps: React.FC = () => {
  const refId = Form.useWatch(edAttrField.referenceId);
  if (!refId) return null;
  return (
    <Form.Item
      label="Атрибут для отображения"
      name={edCompField("labelAttr")}
      rules={[{ required: true }]}
    >
      <SelectFromReference loader={() => loadAllObjectAttsOptions(refId)} />
    </Form.Item>
  );
};
